<div class="mc-spring-board">
  <mat-toolbar class="mc-spring-board-header" color="secondary">
    Insert Snippet
    <span class="mc-fill-remaining-flex-space"></span>
    <button mat-icon-button color="secondary-invert" tabindex="-1" (click)="closeDialog()" [mat-dialog-close]="false">
      <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
    </button>
  </mat-toolbar>

  <div class="mc-spring-board-form-body mc-project-files-add-snippet-dialog-container">
    <mc-project-files-tree-item-preview #snippetPreview [commitId]="data.commitId" [projectId]="data.projectId" [branchName]="data.branchName" [treeFileFilter]="treeFileFilter" [licenseUser]="data.licenseUser" [projectLanguage]="data.projectLanguage" [defaultPath]="ProjectFolder.Snippets + '/'" [usingWorkspaceTree]="data.usingWorkspaceTree"></mc-project-files-tree-item-preview>
    <div class="mat-mdc-form-field-subscript-wrapper">
      <span class="mat-mdc-form-field-error" [class.mc-hidden]="snippetPreview.selectedFilePath !== data.filePath">Selected snippet file is the same as the file opened.</span>
    </div>
  </div>

  <div class="mc-spring-board-footer">
    <button mat-stroked-button (click)="closeDialog()">Cancel</button>
    <button mat-raised-button (click)="onInsertClicked(snippetPreview.selectedFilePath)" color="primary" [disabled]="!snippetPreview.previewSrc || snippetPreview.selectedFilePath === data.filePath || (snippetPreview.previewLoadingState.loading$ | async) || (snippetPreview.previewLoadingState.generalError$ | async)">Insert</button>
  </div>
</div>